import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { decryptValue } from '../../utils/helper';

export default function MaskedValue({ value, maskLength = 44 }) {
    const [visible, setVisible] = React.useState(false);
    return (
        <>
            {visible ? (
                <Box display="flex" alignItems={"center"}>
                    {decryptValue ? decryptValue(value) : value}
                    <IconButton size="small" onClick={() => setVisible(false)}>
                        <Visibility fontSize="small" />
                    </IconButton>
                </Box>
            ) : (
                <Box display="flex" alignItems={"center"}>

                    {'*'.repeat(maskLength)}
                    <IconButton size="small" onClick={() => setVisible(true)}>
                        <VisibilityOff fontSize="small" />

                    </IconButton>
                </Box>
            )}
        </>
    );
}
